module.exports = __webpack_public_path__ + "img/altech-corp.0b6c5615.jpg";